import { FunctionComponent, useMemo } from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import { FileRecord } from "types/file-record";
import { useDownloadFile } from "hooks/use-download-file";

interface FileViewButtonProps {
  file: FileRecord | File;
  readonly publicId?: string;
}

const FileViewButton: FunctionComponent<FileViewButtonProps> = ({ file, publicId }) => {
  const { downloadFile } = useDownloadFile();

  const fileName = useMemo(() => {
    if (file instanceof File) {
      return file.name;
    }

    return file.fileName;
  }, [file]);

  const fileId = useMemo(() => {
    if (file instanceof File) {
      return file.name;
    }

    return file.id;
  }, [file]);

  return (
    <div key={fileName} className="flex items-center space-x-2">
      <DescriptionIcon />
      <a
        target="_blank"
        onClick={async () => await downloadFile(fileId, fileName, publicId)}
        rel="noreferrer"
        className="text-theme-primary hover:underline cursor-pointer"
      >
        {fileName}
      </a>
    </div>
  );
};

export default FileViewButton;
